import { DocumentType } from '@/types';

export type ISellerDocumentTypesReducer = DocumentType[] | null;

const initialState: ISellerDocumentTypesReducer = null;

const documentTypes = (state = initialState, action) => {
    switch (action.type) {
        case 'SELLER_SET_DOCUMENT_TYPES':
            return action.data;
        default:
            return state;
    }
};

export default documentTypes;